import { render, staticRenderFns } from "./simple-snackbar.vue?vue&type=template&id=a8f34614&scoped=true&"
import script from "./simple-snackbar.vue?vue&type=script&lang=js&"
export * from "./simple-snackbar.vue?vue&type=script&lang=js&"
import style0 from "./simple-snackbar.vue?vue&type=style&index=0&id=a8f34614&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f34614",
  null
  
)

export default component.exports